import $ from 'jquery'
function f() {
    // var _width = $(window).width();
    // document.getElementsByTagName("html")[0].style.fontSize = _width * (1/19.2) + "px";
    // //手机适配
    // setTimeout(function(){
    //     $('body').css('opacity',1)
    //     },300)

    var size;
    var winW = window.innerWidth;
    // if (winW <= 1600 && winW > 768) {
    //     size = Math.round(winW / 16);
    //     console.log('111')
    // } else 
    if (winW <= 768) {
        size = Math.round(winW / 7.5);
        if (size > 65) {
            size = 65;
        }
    } else {
        size = 100;
        $('body').addClass('on')
    }
    document.getElementsByTagName("html")[0].style.fontSize  = size+'px'

}
export {
    f
}
